import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

// Order Ops catalog orders (backend: routers/catalog_orders.py).
export async function getBookingCheck(appointmentId) {
  const res = await axios.get(`${API_BASE}/catalog-orders/booking-check/${appointmentId}`, { headers: authHeader() });
  return res.data; // { booking_changed, removed: [...], customer_phone, booked: [{item_id, zoddle_barcode, size, booked_price}] }
}

export async function createPackBooked(appointmentId, packRating = null) {
  const res = await axios.post(`${API_BASE}/catalog-orders/create-pack-booked/${appointmentId}`,
    { pack_rating: packRating }, { headers: authHeader() });
  return res.data;
}

// Dispatch got 409 booked_pieces_in_pack: take the pieces booked for another order out of the pack.
export async function confirmDispatchRemoval(packId) {
  const res = await axios.post(`${API_BASE}/catalog-orders/confirm-dispatch-removal/${packId}`, {}, { headers: authHeader() });
  return res.data;
}

// Dispatch got 409 pack_issues: per piece, ignore it or replace it, once a packer has changed the box.
// resolutions: [{ item_id, action: 'ignore' | 'replace', replacement_barcode? }]
export async function resolvePackIssues(packId, resolutions) {
  const res = await axios.post(`${API_BASE}/catalog-orders/resolve-pack-issues/${packId}`,
    { packer_confirmed: true, resolutions }, { headers: authHeader() });
  return res.data; // { ok, errors?: [{item_id, message}], ignored, replaced }
}

// The pieces to clean out of a pack with issues ({code, items}), without dispatching it.
export async function getPackIssues(packId) {
  const res = await axios.get(`${API_BASE}/catalog-orders/pack-issues/${packId}`, { headers: authHeader() });
  return res.data;
}
